import {
    SET_TECHNICAL_DRAWING_SECTION_TYPE,
    SET_TECHNICAL_DRAWING_SECTION_ALERT_TYPE,
    SET_QUOTE_MODEL_REVISIONS,
    SET_LOADING_DATA,
    SET_UPLOADING_LOADING_DATA,
    SET_ANALYZING_DATA,
    SET_PDFOCR_DATA,
    GET_PDFOCR_DATA_FAILURE,
    SET_WEBVIEWER_INSTANCE,
    SET_QUOTE,
    SET_SELECTED_TAB,
    SET_DRAWING_ANALYSIS_INSPECTION,
    CLEAR_PDFOCR_DATA,
    SET_GENERATED_DRAWING,
    SET_QMR_HOLE_DETAIL,
    SET_QMR_DFMFEEDBACK_REVISION,
    SET_EDIT_PDF_MODE,
    SET_ATTACHMENT_ANNOTATIONS_RESPONSE,
    SET_SHOW_LOADING,
    SET_ERROR_MESSAGE,
    SET_SHOW_RFQ_MODAL,
    SET_UN_SAVE_ANNOTATION,
    SET_PDF_USER_INFO_USERNAME,
    SET_OBFUSCATEFICTIVANNOTATATIONATTIBUTION,
    SET_PDF_URL,
    SET_TECHNICAL_SECTION_BACKGROUD_COLOUR_FOR_WARNING,
    SET_ADDITIONAL_REQUIREMENT_ROW_PDFOCR_DATA,
    SET_ADDITIONAL_REQUIREMENTS_RAW_PDFOCR_DATA_FAILURE,
} from './constants'
import {
    INITIAL_STATE_TYPE,
    TechnicalDrawingSectionType,
    TechnicalDrawingAlertType,
    DFMLayersActionType,
    LoadingData,
    UploadLoadingData,
    AnalyzingData,
    ShowDrawingButton,
    GeneratedDrawing,
} from './types'

/* The initial value of selectedQuoteModelRevisions indicates that this is an async action.
It's type of [QuoteModelRevision] | [] necessitates the consuming components to create a Loading state.
The creation of the Loading state is encouraged to limit the number of re-renders the consuming component undergoes
while processing all the async actions
*/
export const INITIAL_STATE: INITIAL_STATE_TYPE = {
    technicalDrawingSectionType: TechnicalDrawingSectionType.info,
    technicalDrawingAlertType: TechnicalDrawingAlertType.info,
    selectedQuoteModelRevisions: [],
    attachingloading: LoadingData.hide,
    uploadingData: UploadLoadingData.hide,
    analyzingData: AnalyzingData.hide,

    PDFOCRData: null,
    PDFOCRError: null,
    webviewerInstance: null,
    quote: null,
    selectedTabName: null,
    showDrawingButton: ShowDrawingButton.hide,
    generatedDrawing: GeneratedDrawing.hide,
    qmrWithHolesDetail: null,
    qmrWithDfmFeedBack: null,
    editPdfMode: false,
    qmrAttachmentAnnotations: null,
    showLoading: false,
    errorMessage: false,
    showRFQModal: false,
    unsavedAnno: [],
    userName: 'Anonymous',
    obfuscateFictivAnnotationAttribution: false,
    pdfUrl: null,
    backgroudWarningColor: '',
    RAWPDFOCRError: null,
    RAWPDFOCRData: null,
}

export const reducer = (state = INITIAL_STATE, action: DFMLayersActionType) => {
    switch (action.type) {
        case SET_TECHNICAL_DRAWING_SECTION_TYPE: {
            return {
                ...state,
                technicalDrawingSectionType: action.technicalDrawingSectionType,
            }
        }
        case SET_TECHNICAL_DRAWING_SECTION_ALERT_TYPE: {
            return {
                ...state,
                technicalDrawingAlertType: action.technicalDrawingAlertType,
            }
        }
        case SET_QUOTE_MODEL_REVISIONS: {
            return {
                ...state,
                selectedQuoteModelRevisions: action.selectedQuoteModelRevisions,
            }
        }
        case SET_LOADING_DATA: {
            return {
                ...state,
                attachingloading: action.attachingloading || 0,
            }
        }

        case SET_UPLOADING_LOADING_DATA: {
            return {
                ...state,
                uploadingData: action.uploadingData || 0,
            }
        }

        case SET_ANALYZING_DATA: {
            return {
                ...state,
                analyzingData: action.analyzingData || 0,
            }
        }
        case SET_PDFOCR_DATA: {
            return {
                ...state,
                PDFOCRData: action.data,
                PDFOCRError: INITIAL_STATE.PDFOCRError,
            }
        }
        case GET_PDFOCR_DATA_FAILURE: {
            return {
                ...state,
                PDFOCRData: INITIAL_STATE.PDFOCRData,
                PDFOCRError: action.error,
            }
        }
        case CLEAR_PDFOCR_DATA: {
            return {
                ...state,
                PDFOCRData: INITIAL_STATE.PDFOCRData,
                PDFOCRError: INITIAL_STATE.PDFOCRError,
            }
        }

        case SET_WEBVIEWER_INSTANCE: {
            return {
                ...state,
                webviewerInstance: action.instance,
            }
        }
        case SET_QUOTE: {
            return {
                ...state,
                quote: action.quote,
            }
        }
        case SET_SELECTED_TAB: {
            return {
                ...state,
                selectedTabName: action.selectedTabName,
            }
        }

        case SET_DRAWING_ANALYSIS_INSPECTION: {
            return {
                ...state,
                showDrawingButton: action.showDrawingButton,
            }
        }
        case SET_GENERATED_DRAWING: {
            return {
                ...state,
                generatedDrawing: action.generatedDrawing,
            }
        }
        case SET_QMR_HOLE_DETAIL: {
            return {
                ...state,
                qmrWithHolesDetail: action.qmrWithHolesDetail,
            }
        }
        case SET_QMR_DFMFEEDBACK_REVISION: {
            return {
                ...state,
                qmrWithDfmFeedBack: action.qmrWithDfmFeedBack,
            }
        }
        case SET_EDIT_PDF_MODE: {
            return {
                ...state,
                editPdfMode: action.editPdfMode,
            }
        }
        case SET_ATTACHMENT_ANNOTATIONS_RESPONSE: {
            return {
                ...state,
                qmrAttachmentAnnotations: action.qmrAttachmentAnnotations,
            }
        }
        case SET_SHOW_LOADING: {
            return {
                ...state,
                showLoading: action.showLoading,
            }
        }
        case SET_ERROR_MESSAGE: {
            return {
                ...state,
                errorMessage: action.errorMessage,
            }
        }
        case SET_SHOW_RFQ_MODAL: {
            return {
                ...state,
                showRFQModal: action.showRFQModal,
            }
        }
        case SET_UN_SAVE_ANNOTATION: {
            return {
                ...state,
                unsavedAnno: action.unsavedAnno,
            }
        }

        case SET_PDF_USER_INFO_USERNAME: {
            return {
                ...state,
                userName: action.userName,
            }
        }

        case SET_OBFUSCATEFICTIVANNOTATATIONATTIBUTION: {
            return {
                ...state,
                obfuscateFictivAnnotationAttribution:
                    action.obfuscateFictivAnnotationAttribution,
            }
        }

        case SET_PDF_URL: {
            return {
                ...state,
                pdfUrl: action.pdfUrl,
            }
        }
        case SET_TECHNICAL_SECTION_BACKGROUD_COLOUR_FOR_WARNING: {
            return {
                ...state,
                backgroudWarningColor: action.backgroudWarningColor,
            }
        }

        case SET_ADDITIONAL_REQUIREMENT_ROW_PDFOCR_DATA: {
            return {
                ...state,
                RAWPDFOCRData: action.data,
                RAWPDFOCRError: INITIAL_STATE.RAWPDFOCRError,
            }
        }

        case SET_ADDITIONAL_REQUIREMENTS_RAW_PDFOCR_DATA_FAILURE: {
            return {
                ...state,
                RAWPDFOCRData: INITIAL_STATE.PDFOCRData,
                RAWPDFOCRError: action.error,
            }
        }

        default:
            return state
    }
}
